import { useContext } from "react";
import { ToolContext } from "../../context/ToolContext";
import { Snackbar } from "@mui/material";

export const SuperSnackbar = () => {
    const { snack_state } = useContext(ToolContext);
	    return (
	    	<Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={snack_state.alertVal.data.isOpen} autoHideDuration={2000}  message={snack_state.alertVal.data.textBody} sx={{ mb:"80px",width: 'auto',}} ContentProps={{sx: {display: 'block',textAlign: "center", background: "#00BE81"}}}></Snackbar>
	    );
  };